import { addService, getService } from '@4r/mf-host';

export const OFFLINE_SYNC_INDICATOR_SERVICE = 'OfflineSyncIndicator';

export const announceHostSyncIndicator = (): void => {
	if (!getService(OFFLINE_SYNC_INDICATOR_SERVICE)) {
		addService(OFFLINE_SYNC_INDICATOR_SERVICE, { hosted: true });
	}
};
